import React from "react";
import { IsMainMenuHasChildrens } from "../../utils/Common";
import MyRoutes from "../../utils/MyRoutes";
import PrivateLink from "./PrivateLink";
import { Link } from "react-router-dom";

export default function Mainmenu(props) {
  const { group, onItemClick, ...linkProps } = props;
  const hasChildrens = IsMainMenuHasChildrens(group);

  // const RecursiveComponent = ({ data, group }) => {
  //   return data.map((parent, index) => {
  //     if (parent?.children?.length > 0) {
  //       return <RecursiveComponent key={index} data={parent.children} group={group} />;
  //     } else if (parent.title && parent.group === group) {
  //       return (
  //         <li key={index}>
  //           <PrivateLink
  //             to={parent.path}
  //             className="dropdown-item"
  //             onClick={onItemClick} // ✅ collapse when clicked
  //           >
  //             <span>{parent.title}</span>
  //           </PrivateLink>
  //         </li>
  //       );
  //     }
  //     return null; // to avoid warnings
  //   });
  // };
  const RecursiveComponent = ({ data, group }) => {
    return data.map((parent, index) => {
      if (parent?.children?.length > 0) {
        return (
          <RecursiveComponent key={index} data={parent.children} group={group} />
        );
      } else if (parent.title && parent.group === group) {
        return (
          <PrivateLink
            key={index}
            to={parent.path}
            className="dropdown-item"
            onClick={onItemClick}
          >
            <span>{parent.title}</span>
          </PrivateLink>
        );
      }
      return null;
    });
  };


  if (hasChildrens) {
    return (
      <li className="nav-item dropdown hover-dropdown">
        <Link {...linkProps} />
        <ul className="dropdown-menu newdrop" aria-labelledby="navbarDropdown">
          <RecursiveComponent data={MyRoutes} group={group} />
        </ul>
      </li>
    );
  }

  return null;
}
